module.exports = __webpack_public_path__ + "static/media/VMIPO_SignUp.04f88e2d.jpg";